/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basal metabolic rate is the number of calories your body burns at rest to maintain basic functions like breathing and circulation.`)
};

const es_bmr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tasa metabólica basal es el número de calorías que tu cuerpo quema en reposo para mantener funciones básicas como respirar y la circulación.`)
};

const de_bmr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Grundumsatz (BMR) ist die Anzahl an Kalorien, die dein Körper im Ruhezustand verbrennt, um grundlegende Funktionen wie Atmung und Kreislauf aufrechtzuerhalten.`)
};

const nl_bmr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het basaal metabolisme is het aantal calorieën dat je lichaam in rust verbrandt om basisfuncties zoals ademhaling en bloedsomloop in stand te houden.`)
};

const fr_bmr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le métabolisme de base est le nombre de calories que votre corps brûle au repos pour maintenir des fonctions essentielles comme la respiration et la circulation.`)
};

const it_bmr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il metabolismo basale è il numero di calorie che il tuo corpo brucia a riposo per mantenere le funzioni di base come respirazione e circolazione.`)
};

const pt_br2_bmr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A taxa metabólica basal é a quantidade de calorias que seu corpo queima em repouso para manter funções básicas como respiração e circulação.`)
};

const pt_bmr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A taxa metabólica basal é o número de calorias que o corpo queima em repouso para manter funções básicas como a respiração e a circulação.`)
};

const ja_bmr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基礎代謝量とは、呼吸や循環など基本的な機能を維持するために、身体が安静時に消費するカロリー数のことです。`)
};

const zh_bmr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基础代谢率是身体在静息状态下，为维持呼吸、循环等基本功能所消耗的热量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_faq_a1", locale)
	if (locale === "en") return en_bmr_faq_a1(inputs)
	if (locale === "es") return es_bmr_faq_a1(inputs)
	if (locale === "de") return de_bmr_faq_a1(inputs)
	if (locale === "nl") return nl_bmr_faq_a1(inputs)
	if (locale === "fr") return fr_bmr_faq_a1(inputs)
	if (locale === "it") return it_bmr_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_faq_a1(inputs)
	if (locale === "pt") return pt_bmr_faq_a1(inputs)
	if (locale === "ja") return ja_bmr_faq_a1(inputs)
	return zh_bmr_faq_a1(inputs)
};